import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { APIURL } from 'app/Shared/Constant/API_Urls';
import { GridService } from 'app/Shared/Services/grid.service';
import { SharedHttpClientService } from 'app/Shared/Services/shared-http-client.service';
import { UrlsService } from 'app/Shared/Services/urls.service';
import { UserService } from 'app/Shared/Services/user.service';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class OdrReportsService {


    defaultFilterArray: any = [];
    isLoadingResults = true;
    rowcount!: number;
    totalRecords: any = 0;
    startLimit: number = 0;
    endLimit: number = 0;
    defaultData: any;
    dataset: any[] = [];

    
  constructor(private sharedHttpClientService: SharedHttpClientService,
        private userService: UserService,
        private gridService: GridService,
        private readonly urlsService: UrlsService) { 
        
  }

  defaultFilter() {
    this.defaultFilterArray = [
      { 'isdefault': 'true', 'label': 'Report Name', 'columnname': 'reportName', 'filterby': 'IS', 'values': '', 'time': '', 'datatype': 'String', 'disabled': 'false', 'dropdown': '', 'dropdownvalue': '' },
      { 'isdefault': 'true', 'label': 'Report Status', 'columnname': 'reportStatus', 'filterby': 'IS', 'values': '', 'time': '', 'datatype': 'String', 'disabled': 'false', 'dropdown': '', 'dropdownvalue': '' },
    ];
  }

  getDefaultFilters(){
    return this.defaultFilterArray;
  }

  reloadData(){
      let payload = {
        "mpid": this.userService.getActiveMPID(),
        "data": this.defaultFilterArray,
        "startLimit": this.startLimit,
        "endLimit": this.rowcount
    }
      return this.sharedHttpClientService.post(
          this.urlsService.setAPIURl(APIURL.ODR_Reports_List), payload)
          .pipe(map((response: Response) => {
              return response;
            })).subscribe({
              next: (data: any) => {
                this.isLoadingResults = false;
                let response: any = data;
                this.dataset = response.Data;
                this.defaultData = this.dataset;
                this.totalRecords = response.totalCount;
                this.totalRecords = this.gridService.handleNoRecordsPageNumber(this.totalRecords);
              },        
              error: (err: HttpErrorResponse) => {
                this.isLoadingResults = false;
              }
        });  
  }


  getData(payload:any) {
      return this.sharedHttpClientService.post(
          this.urlsService.setAPIURl(APIURL.ODR_Reports_List), payload);
  }
   getEdit(payload:any) {
      return this.sharedHttpClientService.post(
          this.urlsService.setAPIURl(APIURL.ODR_Reports_Edit), payload);
  }
   getGenrateReport(payload:any) {
      return this.sharedHttpClientService.post(
          this.urlsService.setAPIURl(APIURL.ODR_Reports_Generate_Report), payload);
  }
  getCustomerList(payload:any) {
      return this.sharedHttpClientService.post(
          this.urlsService.setAPIURl(APIURL.ODR_Reports_Customer_List), payload);
  }
  Download(payload:any) {
      return this.sharedHttpClientService.post(
          this.urlsService.setAPIURl(APIURL.ODR_Reports_Download), payload);
  }
  Delete(payload:any) {
      return this.sharedHttpClientService.post(
          this.urlsService.setAPIURl(APIURL.ODR_Reports_Delete), payload);
  }
   downloadReport(payload:any) {
      return this.sharedHttpClientService.post(
          this.urlsService.setAPIURl(APIURL.ODR_Reports_Download), payload);
  }


}
